import React, { Component } from 'react';
import PropTypes from 'prop-types';

import SrPartnerSection from 'client/components/SrPartnerSection';
import SrPrequalificationCard from 'client/components/SrPrequalificationCard/SrPrequalificationCard';
import SrPartnerList from 'client/components/SrPartnerList';
import SrText from 'client/components/SrText';
import SrBox from 'client/components/SrBox';

class SrPrequalificationsSection extends Component {
  static propTypes = {
    prequalifications: PropTypes.array.isRequired,
  };

  render() {
    const {
      prequalifications,
    } = this.props;

    return (
      <SrPartnerSection
        title='Pre-Qualifications'
      >
        <SrBox>
          <SrText
            font='greycliff'
          >
            Renters "prequalify" before submitting an application,
            and this information has not yet been verified by our team.
          </SrText>
        </SrBox>
        <SrPartnerList>
          {prequalifications.map(({ prequalification, qualifications }) => (
            <SrPrequalificationCard
              key={prequalification.id}
              prequalification={prequalification}
              qualifications={qualifications}
            />
          ))}
        </SrPartnerList>

      </SrPartnerSection>
    );
  }
}

SrPrequalificationsSection.displayName = 'SrPrequalificationSection';

export default SrPrequalificationsSection;
